import ajax from "../assets/js/ajax";

export default {
  state: {
    showContentHeader: true,
    showContentButton: true,
    chineseEnglish: "", //判断当前中英文状态哦
    userInfo: {}, // 用户信息

    dictData: {
      calMethodOptions: [],
      compareTypeOptions: [],
      isHaveOptions: [],
      calMethodMap: {},
      compareTypeMap: {},
      isHaveMap: {}
    } // 字典数据
  },
  mutations: {
    changeValue(state, played) {
      state.showContentHeader = played.showContentHeader;
      state.showContentButton = played.showContentButton;
    },

    chineseEnglish(state, played) {
      state.chineseEnglish = played;
    },

    getCurrentUser(state, payload) {
      state.userInfo = payload;
    },

    dict(state, payload) {
      const toOptions = arr => {
        return (arr || []).map(item => ({
          label: item.dictLabel,
          value: item.dictValue
        }));
      };
      const toMap = arr => {
        return (
          (arr || []).reduce((obj, cur) => {
            obj[cur.dictValue] = cur.dictLabel;
            return obj;
          }, {}) || {}
        );
      };

      const { calMethodList, compareTypeList, isHaveList } = payload.data || {};
      state.dictData = {
        calMethodOptions: toOptions(calMethodList),
        compareTypeOptions: toOptions(compareTypeList),
        isHaveOptions: toOptions(isHaveList),
        calMethodMap: toMap(calMethodList),
        compareTypeMap: toMap(compareTypeList),
        isHaveMap: toMap(isHaveList),
        combineTypeOpts: [
          {
            label: "低压并网",
            value: "0"
          },
          {
            label: "高压并网",
            value: "1"
          }
          
        ]
      };
    }
  },
  getters: {
    // doneTodos: state => {
    //   return state.todos.filter(todo => todo.done)
    // },
  },
  actions: {
    // async getCurrentUser({ commit }, played) {
    //   commit("getCurrentUser", await ajax("get", `/api/oauth/CurrentUser`,undefined,undefined,{baseURL : "/dev"}));
    // },
    async getCurrentUser({ commit }, played) {
      commit("getCurrentUser", await ajax("get", `/admin/info`));
    },

    async dict({ commit }) {
      commit("dict", await ajax("get", "/dict/data/estimateRegionData"));
    },

    preview({}, url) {
      if (!url) return;

      const link = document.createElement("a");
      link.target = "_blank";
      if (url.startsWith("http")) {
        link.href = url;
      } else {
        link.href =
          (process.env.NODE_ENV === "development"
            ? process.env.baseURL
            : location.origin) + url;
      }
      link.click();
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/order.js